import { SxProps, Theme } from '@mui/material/styles';
import { commonStyles } from '~/theme/styles/commonStyles.ts';

export const otpInputStyles = (theme: Theme): SxProps<Theme> => ({
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.down('sm')]: {
    width: '40px',
    height: '44px',
    borderRadius: '8px',
  },

  [theme.breakpoints.up('sm')]: {
    width: '48px',
    height: '56px',
  },
  width: '35px',
  height: '52px',
  '& .MuiOutlinedInput-input': {
    padding: '0 !important',
    textAlign: 'center',
    height: '100%',
    lineHeight: 'normal',
    fontSize: '26px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '28px',
      marginTop: '8px',
    },

    [theme.breakpoints.up('sm')]: {
      fontSize: '28px',
    },
  },

  '& input': {
    fontFamily: '"Nunito Sans", sans-serif',
    fontWeight: '300',
  },

  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
    margin: 0,
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0, 0, 0, 0.23)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.error.main,
  },
});

type TStyles = {
  backdrop: SxProps<Theme>;
  modalRoot: SxProps<Theme>;
  modalWrapper: SxProps<Theme>;
  modalPaper: SxProps<Theme>;
  modalBody: SxProps<Theme>;
  modalContainer: SxProps<Theme>;
  modalContent: SxProps<Theme>;
  header: SxProps<Theme>;
  verificationMessage: SxProps<Theme>;
  textError: SxProps<Theme>;
  disabled: SxProps<Theme>;
  button: SxProps<Theme>;
  newCode: (theme: Theme) => SxProps<Theme>;
};

export const styles: TStyles = {
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    backdropFilter: 'blur(5px)',
    WebkitBackdropFilter: 'blur(5px)',
  },

  modalRoot: {
    outline: 'none',
  },

  modalWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: 2,
    outline: 'none',
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: 'none',
    },
  },

  modalPaper: (theme: Theme) => ({
    width: '100%',
    maxWidth: '460px',
    padding: theme.spacing(3),
    background: theme.palette.common.white,
    border: `1px solid ${theme.palette.border.subtle}`,
    borderRadius: '10px',
    boxShadow: theme.palette.shadow.modal,
    maxHeight: '90vh',
    overflow: 'hidden',
    outline: 'none',
  }),

  modalBody: (theme: Theme) => ({
    ...(commonStyles.scroll(theme) as object),
    maxHeight: 'calc(90vh - 48px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: theme.spacing(1.5),
    boxSizing: 'border-box',
    textAlign: 'center',
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
  }),

  modalContainer: (theme: Theme) => ({
    ...(commonStyles.scroll(theme) as Object),
    zIndex: 2,
    padding: theme.spacing(3),
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignItems: 'center',
    background: theme.palette.common.white,
    maxHeight: '50%',
    overflowY: 'auto',
    overflowX: 'hidden',
  }),

  modalContent: (theme: Theme) => ({
    color: theme.palette.text.primary,
    textAlign: 'justify',
  }),

  header: (theme: Theme) => ({
    paddingBottom: '12px',
    color: theme.palette.primary.main,
  }),

  verificationMessage: {
    fontSize: '14px',
  },

  textError: (theme: Theme) => ({
    color: theme.palette.error.main,
  }),

  newCode: (theme: Theme) => ({
    color: theme.palette.primary.main,
    cursor: 'pointer',
  }),

  disabled: {
    cursor: 'not-allowed',
    opacity: '0.5',
  },

  button: {
    display: 'block',
    margin: '0 auto',
    marginTop: '15px',
  },
};
